export const tooltipDefaultDelay = 300;
